import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { injectIntl, intlShape } from 'react-intl';
import PropTypes from 'prop-types';
import clone from 'lodash/clone';
import Loader from '../../components/spinner';
import {
    updateSearchTerm,
    getStudentClassroomsRelationRequest,
    getTeacherClassroomsRelationRequest,
    updateSelectedYearGroup,
    assignStudentRequest,
    assignTeacherRequest,
    updateClassrooms,
    closeAssignConfirmationModal,
    cancelUserAssign,
    resetUserClassroomRelation,
    classroomTeacherMappingSuccess,
    assignTeacherToClassroomRequest
} from './actions';
import { getYearGroups } from '../school-roll/actions';
import Modal from '../../components/modal/index';
import ConfirmationMessage from '../../components/confirmation-message/index';
import { Tick } from '../../helpers/icon-dictionary';
import messages from './messages';
import css from './index.scss';
import UserAssign from '../../components/assign-user/index';
import { getClassroomTeacherMapping, assignClassroomFilter } from '../../helpers/utils';

class AssignUser extends Component {
    constructor(props) {
        super(props);
        this.handleOnYearGroupSelection = this.handleOnYearGroupSelection.bind(this);
        this.handleOnSearchClick = this.handleOnSearchClick.bind(this);
        this.handleOnAssignUser = this.handleOnAssignUser.bind(this);
        this.handleOnUnAssignUser = this.handleOnUnAssignUser.bind(this);
        this.handleOnFilterClassroom = this.handleOnFilterClassroom.bind(this);
        this.state = { classrooms: [], teachers: [], existingAssignedTeachers: [] };
        this.searchCriteria = { selectedYearGroup: -1, query: '' };
        const { match } = this.props;
        this.assignType = match.params.assignType;
        this.id = match.params.id;
    }

    static contextTypes = {
        router: PropTypes.object.isRequired
    }

    componentWillReceiveProps(nextProps) {
        const { yearGroupEnum } = this.props;
        if (nextProps.yearGroupEnum !== yearGroupEnum && this.assignType !== 'teacherToClass') {
            this.handleOnYearGroupSelection('', nextProps.yearGroupEnum,
                nextProps.userClassroomRelation.classrooms, true);
        }
    }

    componentDidMount() {
        const { yearGroupEnum, yearGroups, selectedProduct } = this.props;
        if (this.assignType === 'classToStudent') {
            this.props.getStudentClassroomsRelationRequest(this.id, selectedProduct.id);
        } else if (this.assignType === 'classToTeacher') {
            this.props.getTeacherClassroomsRelationRequest(this.id, selectedProduct.id);
        }

        if (yearGroupEnum && this.assignType !== 'teacherToClass') {
            this.handleOnYearGroupSelection('', yearGroupEnum);
        }

        if (yearGroups.length <= 1 && this.assignType !== 'teacherToClass') {
            this.props.getYearGroups();
        }

        if (this.assignType === 'teacherToClass') {
            this.getTeachersAssignObject();
        }
    }

    assignTeacherToStateObject = (searchTerm, assignedIds) => {
        const { teachers } = this.props;
        const classroomId = parseInt(this.id, 10);
        const existingAssignedTeachersIds = this.state.existingAssignedTeachers;
        this.setState({ teachers: getClassroomTeacherMapping(teachers, classroomId,
            searchTerm, assignedIds, existingAssignedTeachersIds, existingAssignedTeachersIds.length > 0) });
        this.setState({ existingAssignedTeachers: existingAssignedTeachersIds });
    }

    getTeachersAssignObject = () => {
        this.assignTeacherToStateObject();
        this.props.classroomTeacherMappingSuccess();
    }

    handleOnFilterClassroom = (studentClassrooms = [], searchCriteria) => {
        const { userClassroomRelation } = this.props;
        if (studentClassrooms.length === 0) {
            studentClassrooms = userClassroomRelation.classrooms;
        }
        this.setState({ classrooms: assignClassroomFilter(studentClassrooms, searchCriteria) });
    }

    handleOnYearGroupSelection = (name, value, studentClassrooms = [], isPageLoad) => {
        const { searchTerm } = this.props;
        this.props.updateSelectedYearGroup(value);
        this.searchCriteria = { selectedYearGroup: value, query: searchTerm };
        if (isPageLoad === undefined && studentClassrooms.length > 0) {
            studentClassrooms.filter(val => !val.isAssigned);
        }
        this.handleOnFilterClassroom(studentClassrooms, this.searchCriteria);
    }

    handleOnSearchClick = (query) => {
        query = query.trim().toLowerCase();
        const { selectedYearGroup, userClassroomRelation } = this.props;
        if (this.assignType === 'teacherToClass') {
            const classroomTeacherMapping = clone(this.state.teachers);
            const assignedIds = classroomTeacherMapping.reduce((teacherProfileIds, val) => {
                if (val.isAssigned) {
                    teacherProfileIds.push(val.id);
                }
                return teacherProfileIds;
            }, []);
            this.assignTeacherToStateObject(query, assignedIds);
        } else {
            this.props.updateSearchTerm(query);
            this.searchCriteria = { selectedYearGroup, query };
            this.handleOnFilterClassroom(userClassroomRelation.classrooms, this.searchCriteria);
        }
    }

    updateClassrooms = (classIds, isAssigned) => {
        const userClassroomRelation = clone(this.state.classrooms);
        const classrooms = userClassroomRelation.map((val) => {
            if (classIds.indexOf(val.id) !== -1) {
                val.isAssigned = isAssigned;
            }
            return val;
        });
        this.setState({ classrooms });
        this.props.updateClassrooms();
    }

    updateClassGroups = (classId, groups) => {
        const userClassroomRelation = clone(this.state.classrooms);
        const classrooms = userClassroomRelation.map((val) => {
            if (val.id === classId) {
                val.groups = groups;
            }
            return val;
        });

        this.setState({ classrooms });
    }

    assignDefaultGroupToClass = (classId) => {
        const userClassroomRelation = clone(this.state.classrooms);
        const classroom = userClassroomRelation.find(val => val.id === classId);
        classroom.groups.map((val) => {
            if (val.isDefault) {
                val.isAssigned = true;
            }
            return val;
        });

        this.setState({ userClassroomRelation });
    }

    updateClassroomTeacherMapping = (listItemIds, isAssigned) => {
        const classroomTeacherRelation = clone(this.state.teachers);
        const teachers = classroomTeacherRelation.map((val) => {
            if (listItemIds.indexOf(val.id) !== -1) {
                val.isAssigned = isAssigned;
            }
            return val;
        });
        this.setState({ teachers });
        this.props.updateClassrooms();
    }

    handleOnAssignUser = (listItemIds) => {
        if (this.assignType === 'teacherToClass') {
            this.updateClassroomTeacherMapping(listItemIds, true);
        } else {
            this.updateClassrooms(listItemIds, true);
        }
    };

    handleOnUnAssignUser = (listItemIds) => {
        if (this.assignType === 'teacherToClass') {
            this.updateClassroomTeacherMapping(listItemIds, false);
        } else {
            this.updateClassrooms(listItemIds, false);
        }
    };

    handleOnGroupSelection = (classId, groups) => {
        this.updateClassGroups(classId, groups);
    };

    handleOnClassroomSelection = (classId) => {
        this.assignDefaultGroupToClass(classId);
    };

    handleOnSave = () => {
        const { selectedProduct } = this.props;
        if (this.assignType !== 'teacherToClass') {
            const assignedClassrooms = [];
            const assignedStudentClassrooms = this.state.classrooms.filter(val => val.isAssigned);
            for (const classroom of assignedStudentClassrooms) {
                const classroomId = classroom.id;
                if (this.assignType === 'classToStudent') {
                    const groupId = classroom.groups.find(group => group.isAssigned).id;
                    assignedClassrooms.push({ classroomId, groupId });
                } else {
                    assignedClassrooms.push({ classroomId });
                }
            }

            if (this.assignType === 'classToStudent') {
                this.props.assignStudentRequest(assignedClassrooms, this.id, this.props.selectedProduct.id);
            } else {
                this.props.assignTeacherRequest(assignedClassrooms, this.id, this.props.selectedProduct.id);
            }
        } else {
            const classroomTeacherMapping = clone(this.state.teachers);
            const existingAssignedTeacherIds = this.state.existingAssignedTeachers;
            const assignedIds = classroomTeacherMapping.reduce((teacherProfileIds, val) => {
                if (val.isAssigned) {
                    teacherProfileIds.push(val.id);
                }
                return teacherProfileIds;
            }, []);
            const teacherClassroomMapping = {
                classroomId: parseInt(this.id, 10),
                productId: selectedProduct.id,
                teachersProfileIdToAssign: assignedIds,
                teachersProfileIdToUnassign: existingAssignedTeacherIds.filter(id => assignedIds.indexOf(id) === -1)
            };
            this.props.assignTeacherToClassroomRequest(teacherClassroomMapping, this.context.router);
        }
    };

    handleOnClose = () => {
        this.props.resetUserClassroomRelation();
        this.context.router.history.goBack();
    }

    closeAssignConfirmationModal = () => {
        this.props.closeAssignConfirmationModal();
        this.props.cancelUserAssign();
        this.context.router.history.goBack();
        this.props.resetUserClassroomRelation();
    }

    render() {
        let header = '';
        const { classrooms, userClassroomRelation, intl, showAssignConfirmationModal,
            isLoadingClassroomDetail, isLoadingClassroomTeacherMapping, disableAssignCancelButton, disableAssignSaveButton, isSaveInProgress,
            selectedYearGroup, yearGroups } = this.props;

        if (this.assignType === 'teacherToClass') {
            const classId = parseInt(this.id, 10);
            header = classrooms.length > 0 ? classrooms.find(val => val.classroomId === classId).name : '';
        } else {
            header =
                `${userClassroomRelation.title ? userClassroomRelation.title : ''} ${userClassroomRelation.firstName} 
             ${userClassroomRelation.lastName}`;
        }

        const confirmationMessage =
            `${intl.formatMessage(messages.classesFor)} ${header} 
             ${intl.formatMessage(messages.updated)}`;

        const modal =
            (<Modal show={showAssignConfirmationModal}>
                <ConfirmationMessage handleOnCloseModal={this.closeAssignConfirmationModal} icon={Tick}>
                    <div>{confirmationMessage}.</div>
                </ConfirmationMessage>
            </Modal>);

        const loader =
            (<div className={css.loader}>
                <Loader color="grey" size="15px" />
            </div>);

        let assignUserView = (<div />);
        if (this.assignType === 'classToStudent') {
            assignUserView =
                    !isLoadingClassroomDetail
                        ? (<div>
                            <UserAssign
                                data={this.state.classrooms}
                                disableAssignCancelButton={disableAssignCancelButton}
                                disableAssignSaveButton={disableAssignSaveButton}
                                handleOnAssignItem={this.handleOnAssignUser}
                                handleOnChildSelection={this.handleOnGroupSelection}
                                handleOnClassroomSelection={this.handleOnClassroomSelection}
                                handleOnClose={this.handleOnClose}
                                handleOnSave={this.handleOnSave}
                                handleOnSearchClick={this.handleOnSearchClick}
                                handleOnUnAssignItem={this.handleOnUnAssignUser}
                                handleOnYearGroupSelection={this.handleOnYearGroupSelection}
                                header={header}
                                isSaveInProgress={isSaveInProgress}
                                selectedYearGroup={`${selectedYearGroup}`}
                                type="student"
                                userClassroomRelation={userClassroomRelation}
                                yearGroups={yearGroups}
                            />
                            {modal}
                        </div>)
                        : <div>{loader}</div>;
        } else if (this.assignType === 'classToTeacher') {
            assignUserView =
                !isLoadingClassroomDetail
                    ? (<div>
                        <UserAssign
                            data={this.state.classrooms}
                            disableAssignCancelButton={disableAssignCancelButton}
                            disableAssignSaveButton={disableAssignSaveButton}
                            handleOnAssignItem={this.handleOnAssignUser}
                            handleOnClose={this.handleOnClose}
                            handleOnSave={this.handleOnSave}
                            handleOnSearchClick={this.handleOnSearchClick}
                            handleOnUnAssignItem={this.handleOnUnAssignUser}
                            handleOnYearGroupSelection={this.handleOnYearGroupSelection}
                            header={header}
                            isSaveInProgress={isSaveInProgress}
                            selectedYearGroup={`${selectedYearGroup}`}
                            type="teacher"
                            userClassroomRelation={userClassroomRelation}
                            yearGroups={yearGroups}
                        />
                        {modal}
                    </div>)
                    : <div>{loader}</div>;
        } else {
            assignUserView =
                isLoadingClassroomTeacherMapping
                    ? (<div>
                        <UserAssign
                            data={this.state.teachers}
                            disableAssignCancelButton={disableAssignCancelButton}
                            disableAssignSaveButton={disableAssignSaveButton}
                            handleOnAssignItem={this.handleOnAssignUser}
                            handleOnClose={this.handleOnClose}
                            handleOnSave={this.handleOnSave}
                            handleOnSearchClick={this.handleOnSearchClick}
                            handleOnUnAssignItem={this.handleOnUnAssignUser}
                            header={header}
                            isSaveInProgress={isSaveInProgress}
                            type="class"
                        />
                        {modal}
                    </div>)
                    : <div>{loader}</div>;
        }

        return assignUserView;
    }
}

AssignUser.propTypes = {
    classrooms: PropTypes.arrayOf(PropTypes.object),
    updateSearchTerm: PropTypes.func,
    getStudentClassroomsRelationRequest: PropTypes.func,
    getTeacherClassroomsRelationRequest: PropTypes.func,
    yearGroups: PropTypes.array,
    match: PropTypes.object.isRequired,
    disableAssignSaveButton: PropTypes.bool,
    yearGroupEnum: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    userClassroomRelation: PropTypes.object,
    updateSelectedYearGroup: PropTypes.func,
    assignStudentRequest: PropTypes.func,
    assignTeacherRequest: PropTypes.func,
    selectedYearGroup: PropTypes.number,
    searchTerm: PropTypes.string,
    showAssignConfirmationModal: PropTypes.bool,
    updateClassrooms: PropTypes.func,
    closeAssignConfirmationModal: PropTypes.func,
    intl: intlShape.isRequired,
    disableAssignCancelButton: PropTypes.bool,
    cancelUserAssign: PropTypes.func,
    resetUserClassroomRelation: PropTypes.func,
    isSaveInProgress: PropTypes.bool,
    selectedProduct: PropTypes.object,
    isLoadingClassroomDetail: PropTypes.bool,
    getYearGroups: PropTypes.func,
    classroomTeacherMappingSuccess: PropTypes.func,
    teachers: PropTypes.array,
    isLoadingClassroomTeacherMapping: PropTypes.bool,
    assignTeacherToClassroomRequest: PropTypes.func
};

function mapStateToProps(state) {
    return {
        classrooms: state.classRoll.classrooms,
        selectedProduct: state.product,
        teachers: state.teacherRoll.teachers,
        yearGroups: state.studentRoll.dataFilterOption.yearGroups,
        isLoadingClassroomDetail: state.assignUser.isLoadingClassroomDetail,
        yearGroupEnum: state.assignUser.yearGroupEnum,
        userClassroomRelation: state.assignUser.userClassroomRelation,
        searchTerm: state.assignUser.searchTerm,
        selectedYearGroup: state.assignUser.selectedYearGroup,
        disableAssignSaveButton: state.assignUser.disableAssignSaveButton,
        showAssignConfirmationModal: state.assignUser.showAssignUserConfirmationModal,
        disableAssignCancelButton: state.assignUser.disableAssignCancelButton,
        isSaveInProgress: state.assignUser.isSaveInProgress,
        isLoadingClassroomTeacherMapping: state.assignUser.isLoadingClassroomTeacherMapping
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        updateSearchTerm,
        getStudentClassroomsRelationRequest,
        getTeacherClassroomsRelationRequest,
        updateSelectedYearGroup,
        assignStudentRequest,
        assignTeacherRequest,
        updateClassrooms,
        closeAssignConfirmationModal,
        cancelUserAssign,
        resetUserClassroomRelation,
        getYearGroups,
        classroomTeacherMappingSuccess,
        assignTeacherToClassroomRequest
    }, dispatch);
}

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(AssignUser));



// WEBPACK FOOTER //
// ./app/containers/assign-user/index.js